import { Api } from 'src/core/decorators/dto/api.decorator';
import { DtoHasApi } from '../shared/dto-has-api.model';

@Api('api/app/query/merged-query')
export class SimpleQueryDto extends DtoHasApi {
  id: number;
  name: string;
}
